import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { clearToken, getOwner, isAuthenticated } from "../lib/auth.ts";

export default function Header() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const owner = getOwner();
  const authed = isAuthenticated();

  const handleLogout = () => {
    clearToken();
    navigate("/login", { replace: true });
  };

  const switchLang = (lng: "ja" | "en") => {
    void i18n.changeLanguage(lng);
  };

  return (
    <header className="nx-header">
      <Link to={authed ? "/" : "/login"} className="nx-logo">
        <img src="/naturenix_logo_green.svg" alt="naturenix" />
      </Link>

      <div className="nx-header-right">
        <div className="nx-lang">
          <button
            type="button"
            className={i18n.resolvedLanguage === "ja" ? "is-active" : ""}
            onClick={() => switchLang("ja")}
          >
            日本語
          </button>
          <span aria-hidden>·</span>
          <button
            type="button"
            className={i18n.resolvedLanguage === "en" ? "is-active" : ""}
            onClick={() => switchLang("en")}
          >
            EN
          </button>
        </div>

        {authed && location.pathname !== "/login" && (
          <div className="nx-owner-chip">
            <span className="nx-owner-chip-name">{owner?.display_name}</span>
            <button type="button" onClick={handleLogout} className="nx-btn-outline">
              {t("common.logout")}
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
